<template>
    <div class="modalStatsWrapper">
        <ModalPlayerLayout :closeModal="closeStatsModal">
            <template v-slot:default>
                <div class="modal_container">
                    <div class="statsModal">
                        <table>
                            <caption></caption>
                            <tbody>
                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">{{ $t('AllTraslation.video') }}</span>
                                    </th>

                                    <td>
                                        <span class="statsValue">
                                            {{ mediaId }}
                                        </span>
                                    </td>
                                </tr>

                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">{{ $t('AllTraslation.viewport') }}</span>
                                    </th>

                                    <td>
                                        <span class="statsValue">
                                            {{ viewport }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">{{ $t('buttons.volume') }}</span>
                                    </th>

                                    <td>
                                        <span class="statsValue">{{ volume }}%</span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">Codec</span>
                                    </th>

                                    <td>
                                        <span class="statsValue">
                                            {{ codec }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">{{ $t('AllTraslation.host') }}</span>
                                    </th>
                                    <td>
                                        <span class="statsValue">{{ clientName }}</span>
                                    </td>
                                </tr>
                                <tr class="stats">
                                    <th class="statsKey">
                                        <span class="statsTitle">{{ $t('modals.rate') }}</span>
                                    </th>

                                    <td>
                                        <span class="statsValue">
                                            {{ bitrate }}
                                            Kbps
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                </div>
            </template>
        </ModalPlayerLayout>
    </div>
</template>
    
<script >
import { defineComponent } from 'vue';
import ModalPlayerLayout from '../../layout/ModalPlayerLayout/ModalPlayerLayout.vue';
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'

export default defineComponent({

    name: 'StatsModal',
    i18n: {
        messages: {
            en: en,
            fr: fr,
        },
    },
    components: {
        ModalPlayerLayout
    },
    props: {
        videoData: {
            type: Object
        },
        player: {
            type: Object
        },
        closeStatsModal: {
            type: Function
        }
    },
    data() {
        return {
            mediaId: "",
            codec: "",
            volume: "",
            clientName: "",
            bitrate: 0,
            viewport: "",

        }
    },
    mounted() {
        let tracks = this.player?.textTracks().tracks_;
        let segmentMetadataTrack = {
            "activeCues": [{
                value: {
                    codecs: "",
                    bandwidth: 0
                }
            }]
        };
        for (let i = 0; i < tracks.length; i++) {
            if (tracks[i].label === 'segment-metadata') {
                segmentMetadataTrack = tracks[i];
            }
        }
        let activeCue = segmentMetadataTrack?.activeCues[0];
        if (activeCue) {
            this.codec = activeCue.value.codecs;
            this.bitrate = activeCue.value.bandwidth / 1000;
        }
        this.mediaId = this.videoData?.playerOptions?.videoId ? this.videoData?.playerOptions?.videoId : this.videoData?.playerOptions?.liveId;
        this.volume = (this.player?.volume() * 100).toFixed(2);
        let container = document.getElementById('vjs_video_3');
        this.viewport = container ? container.offsetWidth + ' x ' + container.offsetHeight : '';
        this.clientName = this.videoData?.client;
    }
})
</script>
  
<style>
.modalStatsWrapper .wrapper {
    background: var(--vm-color-one-08);
    color: var(--vm-color-three);
    width: 15em !important;
    height: max-content;
    top: 2% !important;
    left: 2% !important;
    border-radius: 0.5em;
}

.modalStatsWrapper .btnClose {
    margin: 12% 0 0 auto !important;
}

.statsModal {
    padding-bottom: 1.25em;
}

.statsModal table {
    border-collapse: collapse;
    width: 100%;
}

.statsModal .stats .statsKey {
    text-align: right !important;
    padding-right: 1em !important;
}

.statsModal .stats .statsTitle {
    color: var(--vm-color-three);
    font-size: 0.75em;
    font-weight: 600;
}

.statsModal .stats .statsValue {
    font-size: 0.85em;
    text-align: center;
    color: var(--vm-color-three);
}
</style>